<template>
  <multi-step-dialog :title="title" :showCancel="showCancel" :canConfirm="canConfirm" :showConfirm="showConfirm" :confirmLabel="confirmLabel" :confirmHint="confirmHint" single-step ref="dialog" @confirm="$emit('confirm')">
    <template v-slot:activator="{ on }">
      <slot name="activator" :v-on="on"></slot>
    </template>
    <slot></slot>
  </multi-step-dialog>
</template>

<script>
import MultiStepDialog from './MultiStepDialog.vue';

export default {
  name: "SingleStepDialog",
  components: {
    MultiStepDialog,
  },
  props: {
    title: String,
    showCancel: Boolean,
    canConfirm: {
      default: true,
      type: Boolean,
    },
    showConfirm: {
      default: true,
      type: Boolean,
    },
    confirmLabel: String,
    confirmHint: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  async mounted() {
  },
  methods: {

    async open() {
      this.$refs.dialog.open();
    },

    async close() {
      this.$refs.dialog.close();
    },

    async dismiss(val) {
      this.$refs.dialog.dismiss(val);
    },

    async confirm() {
      this.$refs.dialog.confirm();
    }

  },

  computed: {
    
  },
};
</script>
<style lang="scss">
</style>

